import UserContext from "../../context/UserContext";
import { useContext } from "react";

function About(props) {
  const { isLogged, userData } = useContext(UserContext);
  const { role } = userData;

  return (
    <div className="flex flex-col justify-center items-center h-auto py-32">
      <h1 className="text-2xl font-semibold">About</h1>
      {isLogged && role === "admin" && (
        <button
          className="btn w-36 bg-custom-blue text-black"
          onClick={props.onStartEdit}
        >
          Edit about
        </button>
      )}
      <div className="w-5/6 dark:bg-base-200 bg-gray-300 rounded-md p-5 mt-4">
        <p className="font-semibold text-center">{props.children}</p>
      </div>
    </div>
  );
}

export default About;
